import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/isBefore/index.js';

var require$$54 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$54 as default };
